import { IdentificationClient } from '@frontend/identification/api';
import { Identification, IdentificationType } from '@frontend/identification/types';
import { useModals } from '@frontend/modal';
import { useEffect, useState } from 'react';

import { ApiKeyCardProps } from './api-key-card.component';

export const useApiKeyCard = (props: ApiKeyCardProps) => {
    const [apiKey, setApiKey] = useState<Identification | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const { openModal, closeModal } = useModals();
    const updateApiKeyId = 'update-api-key';
    const createApiKeyId = 'create-api-key';
    const deleteApiKeyId = 'delete-api-key';

    useEffect(() => {
        IdentificationClient.fetchIdentifications({ entity_id: props.entity_id, type: IdentificationType.API_KEY }).then((response) => {
            if (response.results.length > 0) {
                setApiKey(response.results[0]);
            } else {
                setApiKey(null);
            }
            setIsLoading(false);
        });
    }, [props.entity_id]);

    return {
        apiKey,
        isLoading,
        openModal,
        closeModal,
        updateApiKeyId,
        setApiKey,
        createApiKeyId,
        deleteApiKeyId
    };
};
